import React, { useContext } from 'react';
import PatentBadge from './PatentBadge';
import { AuthContext } from '../contexts/AuthContext';
import { Icons } from './Icons';

const MONO = '"Geist Mono", ui-monospace, monospace';
const BRAND_L = '#a78bfa';

const NAV_LINKS = [
  { label: 'FAQ',           href: '/legal/faq' },
  { label: 'Privacy',       href: '/legal/privacy' },
  { label: 'Terms',         href: '/legal/terms' },
  { label: 'Data Deletion', href: '/legal/data-deletion' },
  { label: 'Contact Us',    href: 'mailto:info@nilvisionpro.com' },
];

export default function Footer({ sticky = false }) {
  const auth = useContext(AuthContext);

  return (
    <footer style={{
      ...(sticky ? { position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 30, paddingBottom: 'env(safe-area-inset-bottom, 0px)' } : {}),
      background: '#08080D',
      borderTop: '1px solid rgba(255,255,255,0.06)',
    }}>
      <div style={{ maxWidth: '72rem', margin: '0 auto', padding: '20px 20px' }}>

        {/* Main row */}
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>

          {/* Left: logo + social */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <img src="/nilvision-logo-gradient-background.png" alt="NILVision" style={{ width: 22, height: 22, borderRadius: 5 }} />
              <span style={{ fontSize: '0.8rem', fontWeight: 700, color: 'rgba(255,255,255,0.5)', fontFamily: MONO }}>NILVISION</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              {[
                { href: 'https://www.instagram.com/nilvisionpro', Icon: Icons.Instagram, label: 'Instagram' },
                { href: 'https://x.com/nilvisionpro',             Icon: Icons.Twitter,   label: 'X / Twitter' },
              ].map(({ href, Icon, label }) => (
                <a key={href} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
                  style={{ color: 'rgba(255,255,255,0.18)', transition: 'color 150ms', lineHeight: 0 }}
                  onMouseEnter={e => e.currentTarget.style.color = BRAND_L}
                  onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.18)'}>
                  <Icon style={{ width: 16, height: 16 }} />
                </a>
              ))}
            </div>
          </div>

          {/* Right: nav links */}
          <nav style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px 14px' }}>
            {NAV_LINKS.map(({ label, href }) => (
              <a key={label} href={href}
                target={href.startsWith('mailto') ? undefined : '_blank'}
                rel={href.startsWith('mailto') ? undefined : 'noopener noreferrer'}
                style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.2)', textDecoration: 'none', whiteSpace: 'nowrap', transition: 'color 150ms', fontFamily: MONO }}
                onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.2)'}>
                {label}
              </a>
            ))}
            {auth?.profile?.is_admin && (
              <a href="/admin"
                style={{ fontSize: '0.72rem', color: BRAND_L, textDecoration: 'none', whiteSpace: 'nowrap', fontWeight: 600, fontFamily: MONO }}>
                Admin
              </a>
            )}
          </nav>
        </div>

        {/* Bottom row: copyright + patent */}
        <div style={{
          marginTop: 12, paddingTop: 12,
          borderTop: '1px solid rgba(255,255,255,0.05)',
          display: 'flex', flexWrap: 'wrap', alignItems: 'center',
          justifyContent: 'space-between', gap: 8,
        }}>
          <span style={{ fontSize: '0.68rem', color: 'rgba(255,255,255,0.14)', fontFamily: MONO }}>
            © {new Date().getFullYear()} NILVISION. All rights reserved.
          </span>
          <PatentBadge />
        </div>

      </div>
    </footer>
  );
}
